import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import QueryForm from '../../Pages/Static/queryForm'
// import watchRepaire from '../../../Assets/images/alicias-img/watch-repaire.png'
import jeweleryRepaire from '../../../Assets/images/alicias-img/jewelry-repair.png'
import jeweleryRepaireMobile from '../../../Assets/images/alicias-img/jewelry-repair-mobile.png'
import { isMobileOnly,isMobile } from 'react-device-detect';
const viewJeweleryRepairePage = () => {
  return (
    <>
      <div className='watch_repaire_services_page'>
      <Container fluid>
            <Row>
                <Col sm={12} md={12} lg={12} className="p-0">
                <div>
                    {isMobileOnly?  <Image src={jeweleryRepaireMobile} className='img-fluid'  alt='Oris'/>:   <Image  alt='Oris'  src={jeweleryRepaire} className='img-fluid'/>}
                  
                </div>
                </Col>
            </Row>
      </Container>
      <QueryForm/>
      </div>
    </>
    
  )
}

export default viewJeweleryRepairePage
